/* eslint-disable @typescript-eslint/ban-ts-comment */
export const useMultipleMonitors = () => {
    // @ts-ignore
    if ("isExtended" in screen && typeof screen.isExtended === "boolean") {
      // @ts-ignore
      return screen.isExtended;
    }
    return false;
  }
  